export const CONTENT_REPO_ORIGIN = 'https://cdn.websky.aero/content';
export const FALLBACK_IATA_CODE = 'ZZ';
